import React from 'react';
import { trans } from '../../../../localization';
import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';

class NowPortalOrderFilter extends React.Component {
  constructor(props) {
    super(props);

    const { metadata, stores } = this.props;

    this.orderStatusOptions = metadata.summary_statuses.map(item => ({
      value: item.value,
      label: item.name,
    }));
    this.transactionTypeOptions = metadata.payment_channel_ids.map(item => ({
      value: item.value,
      label: item.name,
    }));
    this.storeOptions = stores.map(item => ({
      value: item.id,
      label: item.name,
    }));
  }

  handleChange = (name, value) => {
    const { handleChangeFilters } = this.props;
    handleChangeFilters(name, value);
  };

  handleSearch = () => {
    const { handleSearch } = this.props;
    handleSearch();
  };

  handleExport = () => {
    const { handleSearch } = this.props;
    handleSearch(true);
  };

  render() {
    const { filters } = this.props;

    const {
      fromDate, toDate, status, transactionType, store,
    } = filters;

    return (
      <FilterWrapper>
        <InputWrapper label={trans('time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => this.handleChange('fromDate', date)}
            handleChangeToDate={date => this.handleChange('toDate', date)}
          />
        </InputWrapper>
        <InputWrapper label={trans('common_status')} width={300}>
          <NowSelect
            value={status}
            options={this.orderStatusOptions}
            onChange={value => this.handleChange('status', value)}
          />
        </InputWrapper>
        <InputWrapper label={trans('np_transaction_type')} width={300}>
          <NowSelect
            value={transactionType}
            options={this.transactionTypeOptions}
            onChange={value => this.handleChange('transactionType', value)}
          />
        </InputWrapper>
        <InputWrapper label={trans('store')} width={300}>
          <NowSelect
            value={store}
            options={this.storeOptions}
            onChange={value => this.handleChange('store', value)}
          />
        </InputWrapper>
        <InputWrapper>
          <button
            type="button"
            className="btn btn-white mr-2"
            onClick={this.handleSearch}
          >
            {trans('search')}
          </button>
          <button
            type="button"
            className="btn btn-red"
            onClick={this.handleExport}
          >
            {trans('Export')}
          </button>
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

export default NowPortalOrderFilter;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalOrder/component/NowPortalOrderFilter.jsx